import React, { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useUserRedirectionLink } from 'hooks/useUserRedirectionLink'

import { eventLogger } from 'services/eventLogger.service'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'

import phoneImage from 'assets/images/wellness-app-phone-image.webp'

import { StyledAppWellness as S } from './AppWellness.styles'

export const AppWellness: React.FC = () => {
  const { t } = useTranslation()
  const redirectionLink = useUserRedirectionLink()

  useEffect(() => {
    eventLogger.logGettingAppShown()
  }, [])

  const handleDownloadApp = () => {
    googleAnalyticsLogger.logDownloadButtonPressed()
    eventLogger.logDownloadTap()

    window.location.href = redirectionLink
  }

  return (
    <S.Wrapper>
      <S.Content>
        <S.InboxNotice />

        <S.Title>
          <Trans i18nKey="wellnessApp.title" />
        </S.Title>

        <S.Subtitle>
          <Trans i18nKey="wellnessApp.subtitle" />
        </S.Subtitle>

        <S.PhoneImage src={phoneImage} alt="" />

        <S.ButtonContainer>
          <S.DownloadButton type="button" onClick={handleDownloadApp}>
            {t('wellnessApp.buttonText')}
          </S.DownloadButton>
        </S.ButtonContainer>
      </S.Content>
    </S.Wrapper>
  )
}
